import { render, staticRenderFns } from "./BookedTravel.vue?vue&type=template&id=1594835d&scoped=true"
import script from "./BookedTravel.vue?vue&type=script&lang=js"
export * from "./BookedTravel.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1594835d",
  null
  
)

export default component.exports